/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import { createId } from '@/utils/general'
import Styles from './styles.module.sass'
import IconsList from '@/components/icons/IconsList'
import Modal from './components/Modal'
import {
  getCookie,
  warningTexts,
  networks
} from './handlers'

const SelectNetwork = ({
  textBeta = warningTexts.beta,
  textPdsApi = warningTexts.pdsApi,
  redirectToIndex = false,
  environment
}) => {
  const defaultNetwork = environment || networks[0].id
  const network = getCookie(document.cookie)
  const [curNetwork, setCurNetwork] = useState(network || defaultNetwork)
  const [tempNetwork, setTempNetwork] = useState()
  const [modal, setModal] = useState(false)
  const [textModal, setTextModal] = useState(textBeta)
  const createCookie = network => {
    document.cookie = `network=${network};path=/`
  }
  const cUrl = window.location.href
  const redirectUrl = redirectToIndex ? '/' : cUrl
  const setNetwork = network => {
    setCurNetwork(network)
    createCookie(network)
  }
  const changeNetwork = (e) => {
    const network = e.target.value

    if (network !== 'production') {
      setTempNetwork(network)
      setModal(true)
      setTextModal(
        network === 'beta'
          ? textBeta
          : textPdsApi
      )
    } else {
      setNetwork(network)
      window.location.replace(redirectUrl)
    }
  }
  const cancelModal = () => {
    setModal(false)
  }
  const acceptModal = () => {
    setCurNetwork(tempNetwork)
    createCookie(tempNetwork)
    setModal(false)
    window.location.replace(redirectUrl)
  }

  const options = networks.map(network => (
    <option
      key={createId()}
      value={network.id}
      disabled={network.disabled}
      className={network.disabled ? Styles.optionDisabled : ''}
    >
      { network.name }
    </option>
  ))

  !network && createCookie(defaultNetwork)

  return (
    <>
      <div className={`${Styles.container} flex mr-sm`}>
        <div className={`mr-xs ${Styles.icon}`}>
          <IconsList icon="zetonium" asImage={true} width="30px" height="30px" />
        </div>
        <select
          name="networks"
          value={curNetwork}
          onChange={changeNetwork}
          className={Styles.selectNetwork}
        >
          { options }
        </select>
      </div>
      { modal &&
        <Modal
          onAccept={acceptModal}
          onCancel={cancelModal}
          text={textModal}
        />
      }
    </>
  )
}

export default SelectNetwork
